import { jotaiStore } from '@shared/store/jotai/jotai-store';

import { globalAtom } from '@shared/store/slices/global.atom';

export type { GlobalState } from '@shared/store/slices/global.atom';

export const changeLandingPageView = (viewType: string) => {
  jotaiStore.set(globalAtom, (prev) => ({ ...prev, landingPageView: viewType }));
};
